export const SNS_LIST = [
  {
    name: "GitHub",
    url: "https://github.com/snamiki1212",
  },
  {
    name: "Twitter",
    url: "https://twitter.com/snamiki1212",
  },
];
